import debug from 'debug';

export const MINIMUM_MS_VERSION_FOR_V2 = '1.1.0';

export const baseLog = debug('Verifone');
